// ======================================================================
// File Name       : container
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { STRUCTURE_LEVEL } from '../../constants';

export function postContainerGetStructure(data) {
  // Default コンテナ構造取得API's parameter
  const GET_STRUCTURE_DEFAULT = {
    targetCourseSecernId: null,
    targetBoxSecernId: null,
    recursiveType: STRUCTURE_LEVEL.DIRECT,
  };

  return commonCallApi({
    path: 'container/GetStructure',
    data: { ...GET_STRUCTURE_DEFAULT, ...data },
  });
}

export function postContainerGetStructureByCourseSecernId(courseSecernId) {
  return postContainerGetStructure({
    targetCourseSecernId: courseSecernId,
    recursiveType: STRUCTURE_LEVEL.ALL,
  });
}

export function exportCSV(param) {
  return commonCallApi({
    path: 'container/GetStructureList',
    data: null,
    institutionId: 1,
  });
}

export function postContainerGetAllStructure() {
  const GET_STRUCTURE_DEFAULT = {
    targetCourseSecernId: null,
    targetBoxSecernId: null,
    recursiveType: STRUCTURE_LEVEL.ALL,
  };

  return commonCallApi({
    path: 'container/GetStructure',
    data: { ...GET_STRUCTURE_DEFAULT },
  });
}
